import React, { useEffect, useState } from "react";

import SearchBar from "components/templates/common/main/SearchBar";

import MainNavgation from "components/templates/common/main/Navgation";
import { useRouter } from "next/router";
import InterestMainPage from "components/pages/interest/Index";
import StockLIstIndex from "components/templates/common/main/StockLIstIndex";
import MyStockIndex from "components/templates/common/main/mystock/Index";
import FeedIndex from "components/templates/common/main/feed/Index";
import MainPortfolioIndex from "components/templates/common/main/portfolio/Index";

function Main({
  isMobile,
  isLoginUser,
  portId,
  initialHighScoreList,
  initialHotTopicList,
  initialMainIndex,
}: {
  isMobile: boolean;
  isLoginUser: boolean;
  portId: number | null;
  initialHighScoreList?: any[] | null;
  initialHotTopicList?: any[] | null;
  initialMainIndex?: { index?: any[] } | null;
}) {
  const router = useRouter();
  const { type } = router.query;

  const explore = (
    <StockLIstIndex
      isMobile={isMobile}
      isLoginUser={isLoginUser}
      initialHighScoreList={initialHighScoreList}
      initialHotTopicList={initialHotTopicList}
      initialMainIndex={initialMainIndex}
    />
  );

  if (isMobile) {
    return (
      <main className="min-w-[360px] h-auto max-w-[800px]">
        <MainNavgation isMobile={isMobile} />
        {(!type || type === "" || type === "explore") && explore}
        {type === "my" && (
          <div>
            <InterestMainPage isMobile={isMobile} />
          </div>
        )}
        {type === "portfolio" && (
          <div>
            <MainPortfolioIndex isMobile={isMobile} portId={portId} />
          </div>
        )}
        {type === "stock" && router.locale === "ko" && (
          <MyStockIndex isMobile={isMobile} isLoginUser={isLoginUser} />
        )}
        {type === "feed" && (
          <div>
            <FeedIndex isMobile={isMobile} />
          </div>
        )}
      </main>
    );
  }

  return (
    <main className={"min-w-[360px] max-w-[800px] h-auto w-screen "}>
      <MainNavgation isMobile={isMobile} />
      {(!type || type === "" || type === "explore") && explore}
      {type === "my" && (
        <div>
          <InterestMainPage isMobile={isMobile} />
        </div>
      )}
      {type === "portfolio" && (
        <div>
          <MainPortfolioIndex isMobile={isMobile} portId={portId} />
        </div>
      )}
      {type === "feed" && (
        <div>
          <FeedIndex isMobile={isMobile} />
        </div>
      )}
    </main>
  );
}

export default Main;
